'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPlay = function IoPlay(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 18.2c0.6 0.5 0.9 1.1 0.9 1.8s-0.3 1.3-0.9 1.8l-21.7 13c-0.3 0.1-0.5 0.2-0.8 0.2-0.9 0-1.6-0.7-1.6-1.6v-26.8c0-0.9 0.7-1.6 1.6-1.6 0.3 0 0.6 0.1 0.8 0.2z' })
        )
    );
};

exports.default = IoPlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/play.js
// module id = 2412
// module chunks = 0